import { ActionTypes } from "../constants";

export default function setAppConfig(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_APP_CONFIG:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}